module.exports = __webpack_public_path__ + "static/web-8-1fee53def2d244e5a52db5b16e59678a.mp4";